function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconPlus = function SvgIconPlus(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 23 23",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.4 1.2c6.2 0 11.2 5 11.2 11.3 0 6.2-5 11.2-11.2 11.2s-11.2-5-11.2-11.2C1.3 6.3 6.3 1.2 12.4 1.2",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ee751c"
    },
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 7.5v3.8h3.7v2.5h-3.7v3.8h-2.5v-3.8H7.5v-2.5h3.8V7.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    },
    transform: "translate(-1 -1)"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconPlus);
export default ForwardRef;